export default () => ({
  slideIn(element: HTMLElement) {
    this.$nextTick(() => {
      element.classList.add("show");
    });
  },

  slideOut(element: HTMLElement) {
    element.classList.remove("show");
    element.classList.add("hide");
    setTimeout(() => element.remove(), 200);
  },
});
